export default __webpack_public_path__ + "static/pexels-karolina-grabowska-5978712-edf98a29f6246ab0a9ff070c771ba942.jpg";